import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={15}
    fill="none"
    {...props}
  >
    <path
      stroke="#b39c68"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m.988 1.5 19.059 12.875M.974 14.36 20.004 1.44"
    />
  </svg>
)
export default SvgComponent
